import './action-menu-movement.scss'

import { defineComponent } from 'vue'
import { faCheck, faTimes, faPlus, faStepBackward, faUndo } from '@fortawesome/free-solid-svg-icons'

import { MovementTypes, MovementLifecycleStates, LinkableItemLifecycleStates } from '@skinsoft/types'
import { TrackingRoutes } from '@skinsoft/const'
import { movementSelectors } from '@skinsoft/selectors'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import {
    ADD_ACCESSORY_TOPIC,
    ADD_CONTAINER_TOPIC,
    ADD_ITEM_TOPIC,
    ADD_SPECIMEN_TOPIC,
    CANCEL_MOVEMENT_TOPIC,
    CLOSE_MOVEMENT_TOPIC,
    CREATE_MOVEMENT_TOPIC,
    CREATE_SIMPLE_MOVEMENT_TOPIC,
    DELETE_MOVEMENT_TOPIC,
    RETURN_MOVEMENT_TOPIC,
    START_ITEM_TRANSIT_TOPIC,
} from '../../../../busTopics'

export const ActionMenuMovement = defineComponent({
    mixins: [reactiveVueMixin],
    props: ['entityDataStore'],
    template: require('./action-menu-movement.html'),
    data() {
        return {
            plusIcon: faPlus,
            checkIcon: faCheck,
            crossIcon: faTimes,
            undoIcon: faUndo,
            stepBackwardIcon: faStepBackward,
            entity: null as any,

            canAddItem: false,
            canBeClose: false,
            canBeCancel: false,
            canBeReturn: false,
            canCreate: false,
            canStartMovement: false,

            displayDeleteConfirmation: false,
        }
    },
    created() {
        if (this.$route.name === TrackingRoutes.MOVEMENT) {
            this.subscribeToEntity()
        } else if (this.$route.name === TrackingRoutes.MOVEMENTS) {
            this.canCreate = true
        }
    },
    methods: {
        addItem() {
            this.emitOnBus(ADD_ITEM_TOPIC)
            this.$emit('toggle')
        },

        addSpecimen() {
            this.emitOnBus(ADD_SPECIMEN_TOPIC)
            this.$emit('toggle')
        },

        addContainer() {
            this.emitOnBus(ADD_CONTAINER_TOPIC)
            this.$emit('toggle')
        },

        addAccessory() {
            this.emitOnBus(ADD_ACCESSORY_TOPIC)
            this.$emit('toggle')
        },

        cancelMovement() {
            this.emitOnBus(CANCEL_MOVEMENT_TOPIC)
            this.$emit('toggle')
        },

        closeMovement() {
            this.emitOnBus(CLOSE_MOVEMENT_TOPIC)
            this.$emit('toggle')
        },

        deleteMovement() {
            this.emitOnBus(DELETE_MOVEMENT_TOPIC)
            this.$emit('toggle')
        },

        returnMovement() {
            this.emitOnBus(RETURN_MOVEMENT_TOPIC)
        },

        createMovement() {
            this.emitOnBus(CREATE_MOVEMENT_TOPIC)
            this.$emit('toggle')
        },

        createSimpleMovement() {
            this.emitOnBus(CREATE_SIMPLE_MOVEMENT_TOPIC)
            this.$emit('toggle')
        },

        subscribeToEntity() {
            this.subscribeTo(
                this.entityDataStore.fetchOne(this.$route.params.id),
                entity => {
                    this.entity = entity
                },
                'entity',
            )
        },

        showDeleteConfirmation(value: boolean) {
            this.displayDeleteConfirmation = value
        },

        onDataStoreChange() {
            this.unsubscribeFrom('entity')
            if (this.$route.name === TrackingRoutes.MOVEMENT) {
                this.subscribeToEntity()
            } else if (this.$route.name === TrackingRoutes.MOVEMENTS) {
                this.unsubscribeFrom('entity')
                this.entity = null
            }
        },

        onEntityChange(entity) {
            const availableLifecycleStates = movementSelectors.availableLifecycleStates(entity)
            const state = movementSelectors.state(entity)
            const movementType = movementSelectors.movementType(entity)

            this.canBeClose = state === MovementLifecycleStates.IN_PROGRESS
            this.canBeCancel = availableLifecycleStates.includes(MovementLifecycleStates.CANCELED)
            this.canBeReturn =
                movementType !== MovementTypes.RETURN && state === MovementLifecycleStates.FINALIZED
            this.canAddItem = state != null && state !== MovementLifecycleStates.FINALIZED

            this.canStartMovement =
                this.canAddItem &&
                movementSelectors.linkableItems(entity).some(
                    item => item.state?.name === LinkableItemLifecycleStates.SELECTED
                )

            this.canCreate = this.$route.name === TrackingRoutes.MOVEMENTS
        },

        startItemTransit() {
            this.emitOnBus(START_ITEM_TRANSIT_TOPIC)
            this.$emit('toggle')
        },
    },
    watch: {
        '$route': {
            handler: 'onDataStoreChange',
            deep: true,
        },
        entityDataStore: {
            handler: 'onDataStoreChange',
        },
        entity: {
            handler: 'onEntityChange',
            deep: true,
            immediate: true,
        },
    },
})
